<template>
    <section class="flex flex-col lg:flex-row bg-[#2B2A29]">
        <!-- Left Content -->
        <div :class="newStyle ? 'lg:order-1 order-2 lg:px-8 px-0 lg:pb-8 pb-0' : 'px-8'"
            class="flex flex-col justify-center xl:py-12 py-8 w-full text-white lg:w-5/11 lg:p-12 xl:p-20 xl:pb-24 bg-[#32302F]">
            <h2 class="mb-6 font-bold leading-tight font-ww-bold xl:!leading-tight" v-html="title"
                :class="newStyle ? 'text-4xl lg:text-left lg:px-0 px-8' : 'text-3xl lg:text-38 md:text-3xl lg:text-left text-center'">
            </h2>

            <div class="space-y-6 text-gray-200 font-ww-regular xl:!leading-8" v-html="content"
                :class="newStyle ? 'text-xl lg:px-0 px-8 lg:pb-0 pb-8' : 'lg:text-xl md:text-lg text-base'">
            </div>

            <div class="bg-[#0D0500] xl:py-20 md:py-12 py-6 px-8"
                :class="newStyle ? 'lg:hidden md-max:!px-4 md-max:py-10' : 'hidden'">
                <div class="grid grid-cols-3 gap-8 text-center">
                    <div class="flex flex-col items-center">
                        <div class="flex justify-center items-center mb-4 h-16">
                            <nuxt-img :src="icon1" loading="lazy" format="webp" alt="Low Acid" width="49" height="62"
                                class="object-contain w-auto h-12 brightness-0 invert" />
                        </div>
                        <p class="text-white font-ww-regular"
                            :class="newStyle ? 'text-17 md:leading-tight' : 'md:text-17 text-sm leading-tight'"
                            v-html="icon1Text"></p>
                    </div>

                    <div class="flex flex-col items-center">
                        <div class="flex justify-center items-center mb-4 h-16">
                            <nuxt-img :src="icon2" loading="lazy" format="webp" width="59" height="59"
                                alt="Tested for Toxins" class="object-contain w-auto h-12 brightness-0 invert" />
                        </div>
                        <p class="text-sm text-white md:text-17 font-ww-regular"
                            :class="newStyle ? 'text-17 md:leading-tight' : 'md:text-17 text-sm leading-tight'"
                            v-html="icon2Text"></p>
                    </div>

                    <div class="flex flex-col items-center">
                        <div class="flex justify-center items-center mb-4 h-16">
                            <nuxt-img :src="icon3" loading="lazy" format="webp" width="55" height="60"
                                alt="Free Shipping" class="object-contain w-auto h-12 brightness-0 invert" />
                        </div>
                        <p class="text-sm text-white md:text-17 font-ww-regular"
                            :class="newStyle ? 'text-17 md:leading-tight' : 'md:text-17 text-sm leading-tight'"
                            v-html="icon3Text"></p>
                    </div>
                </div>
            </div>

        </div>

        <!-- Right Content -->
        <div class="flex flex-col w-full lg:w-6/11" :class="newStyle ? 'lg:order-2 order-1' : ''">
            <!-- Product Image Section -->
            <div class="overflow-hidden relative w-full h-full">
                <nuxt-img :src="productImage" alt="Lifeboost Cold Brew"
                    class="object-cover mx-auto h-full lg:w-full lg:mx-0" loading="lazy" format="webp" width="516"
                    height="652" sizes="xs:330px sm:440px md:751px lg:1008px xl:493px" />
            </div>

            <!-- Icons Section -->
            <div class="bg-[#0D0500] xl:py-20 md:py-12 py-6 px-8" :class="newStyle ? 'lg:block hidden' : ''">
                <div class="grid grid-cols-3 gap-8 text-center" :class="newStyle ? 'md-max:gap-2' : ''">
                    <div class="flex flex-col items-center">
                        <div class="flex justify-center items-center mb-4 h-16">
                            <nuxt-img :src="icon1" loading="lazy" format="webp" alt="Low Acid" width="49" height="62"
                                class="object-contain w-auto h-12 brightness-0 invert" />
                        </div>
                        <p class="text-sm leading-tight text-white md:text-17 font-ww-regular" v-html="icon1Text"></p>
                    </div>

                    <div class="flex flex-col items-center">
                        <div class="flex justify-center items-center mb-4 h-16">
                            <nuxt-img :src="icon2" loading="lazy" format="webp" width="59" height="59"
                                alt="Tested for Toxins" class="object-contain w-auto h-12 brightness-0 invert" />
                        </div>
                        <p class="text-sm leading-tight text-white md:text-17 font-ww-regular" v-html="icon2Text"></p>
                    </div>

                    <div class="flex flex-col items-center">
                        <div class="flex justify-center items-center mb-4 h-16">
                            <nuxt-img :src="icon3" loading="lazy" format="webp" width="55" height="60"
                                alt="Free Shipping" class="object-contain w-auto h-12 brightness-0 invert" />
                        </div>
                        <p class="text-sm leading-tight text-white md:text-17 font-ww-regular" v-html="icon3Text"></p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    newStyle: {
        type: Boolean,
        default: false
    },
    title: {
        type: String,
        default: 'The Love Your Coffee Guarantee'
    },
    content: {
        type: String,
        default: 'Coffee is personal. The source of beans and roasting process make each coffee unique.<br><br>At Lifeboost, we want you to love your coffee so you realize the long-term benefits of drinking our clean, low acid, non-GMO, single-origin coffee.<br><br>If you don’t absolutely love your Lifeboost Coffee product, let us know within 30 days of your order and we’ll exchange it for free or give you a full refund.<br><br>We encourage you to open a bag of our coffee, take in the aroma, make a cup, and try it for yourself. If you don’t love it, even if the bag is opened, we’ll help you exchange it for a roast or flavor you might like better or give you a full refund.<br><br>The fastest way to get help with an exchange is to call us at 1-800-479-1596. Or, you can email us at support@lifeboostcoffee.com and we’ll help you with your order.'
    },
    productImage: {
        type: String,
        default: '/assets/images/cold-brew.jpg'
    },
    icon1: {
        type: String,
        default: '/assets/images/bogo-low-acid.svg'
    },
    icon1Text: {
        type: String,
        default: 'Low Acid<br>Beans'
    },
    icon2: {
        type: String,
        default: '/assets/images/bogo-party-tested.svg'
    },
    icon2Text: {
        type: String,
        default: '3rd Party Tested<br>for Mycotoxins'
    },
    icon3: {
        type: String,
        default: '/assets/images/bogo-free-shipping.svg'
    },
    icon3Text: {
        type: String,
        default: 'Free<br>Shipping'
    }
});

defineBuilderComponent({
    friendlyName: 'Split Content Product',
    inputs: [
        {
            name: 'newStyle',
            type: 'boolean',
            defaultValue: false,
            friendlyName: 'New Style'
        },
        {
            name: 'title',
            type: 'text',
            defaultValue: 'The Love Your Coffee Guarantee',
            friendlyName: 'Title'
        },
        {
            name: 'content',
            type: 'richText',
            defaultValue: 'Coffee is personal. The source of beans and roasting process make each coffee unique.<br><br>At Lifeboost, we want you to love your coffee so you realize the long-term benefits of drinking our clean, low acid, non-GMO, single-origin coffee.<br><br>If you don’t absolutely love your Lifeboost Coffee product, let us know within 30 days of your order and we’ll exchange it for free or give you a full refund.<br><br>We encourage you to open a bag of our coffee, take in the aroma, make a cup, and try it for yourself. If you don’t love it, even if the bag is opened, we’ll help you exchange it for a roast or flavor you might like better or give you a full refund.<br><br>The fastest way to get help with an exchange is to call us at 1-800-479-1596. Or, you can email us at support@lifeboostcoffee.com and we’ll help you with your order.',
            friendlyName: 'Content'
        },
        {
            name: 'productImage',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '/assets/images/cold-brew.jpg',
            friendlyName: 'Product Image'
        },
        {
            name: 'icon1',
            type: 'file',
            allowedFileTypes: ['svg', 'png', 'jpg'],
            defaultValue: '/assets/images/bogo-low-acid.svg',
            friendlyName: 'Icon 1'
        },
        {
            name: 'icon1Text',
            type: 'richText',
            defaultValue: 'Low Acid<br>Beans',
            friendlyName: 'Icon 1 Text'
        },
        {
            name: 'icon2',
            type: 'file',
            allowedFileTypes: ['svg', 'png', 'jpg'],
            defaultValue: '/assets/images/bogo-party-tested.svg',
            friendlyName: 'Icon 2'
        },
        {
            name: 'icon2Text',
            type: 'richText',
            defaultValue: '3rd Party Tested<br>for Mycotoxins',
            friendlyName: 'Icon 2 Text'
        },
        {
            name: 'icon3',
            type: 'file',
            allowedFileTypes: ['svg', 'png', 'jpg'],
            defaultValue: '/assets/images/bogo-free-shipping.svg',
            friendlyName: 'Icon 3'
        },
        {
            name: 'icon3Text',
            type: 'richText',
            defaultValue: 'Free<br>Shipping',
            friendlyName: 'Icon 3 Text'
        }
    ]
});
</script>
